export default class BaseTestCardConstants {
    static readonly MaxWidth = 34.5;
    static readonly MaxImageWidth = 34.25;
    static readonly MaxTagCount = 5;
}
